import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PodsService {

  appId: number;
  searchByAppropriatorString: string;
  searchByApplicationPackageYearString: string;

  // This is the list of all PODs, used by the pod-form at the top of the new/existing permit page
  private podsSource = new BehaviorSubject<Pod[]>([]);
  currentPods = this.podsSource.asObservable();

  // This is a single POD by POD Id, used by the new-permit component to grab the associated App Id
  private podByPodIdSource = new BehaviorSubject<Pod>(null);
  currentPodByPodId = this.podByPodIdSource.asObservable();

  // This is the selected POD from the pod-form at the top of the new/exising permit page
  private podSource = new BehaviorSubject<string>("");
  currentPod = this.podSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getPods(appId?: number, appYear?: number) {
    // if an AppropriatorId was pased in, set in for the search otherwise return everything.
    if ( appId > 0) {
      this.searchByAppropriatorString = `&AppropriatorId=${appId}`;
    } else {
        this.searchByAppropriatorString = '';
    }

    var d = new Date();
    var currentYear = d.getFullYear();
    if (appYear) { currentYear = appYear; }

    this.searchByApplicationPackageYearString = `Year=${String(currentYear)}`;

    this.http.get<Pod[]>(`${this.baseUrl}api/PermitPointOfDiversion/search?${this.searchByApplicationPackageYearString}${this.searchByAppropriatorString}`).subscribe(
      result => {
        if (result) {
          this.changePods(result);
        }
      },
      error => console.error(error)
    );
  }

  getPodByPodId(podId: number) {
    this.http.get<Pod>(`${this.baseUrl}api/PermitPointOfDiversion/${podId}`).subscribe(
      result => {
        if (result) {
          this.changePodByPodId(result);
        }
      },
      error => console.error(error)
    );
  }

  postPod(permitAppropriatorId, name, appropriatorId, lon, lat, projectTypeId, diversionTypeId, sourceName, diversionCFSMax, reachNumber) {
    let data: any = {};
    data.Name = name;
    data.appropriatorId = appropriatorId;
    data.Latitude = lat;
    data.Longitude = lon;
    data.diversionTypeId = diversionTypeId;
    data.sourceName = sourceName;
    data.diversionCFSMax = diversionCFSMax;
    data.reachNumber = reachNumber;

    this.http.post(`${this.baseUrl}api/PermitPointOfDiversion`, data, { observe: 'response' }).subscribe(response => {
      if(response.status === 200) {
        this.getPods(permitAppropriatorId);
      }
    });
  }

  putPod(permitAppropriatorId, editPOD: Pod) {
    this.http.put(`${this.baseUrl}api/PermitPointOfDiversion`, editPOD, { observe: 'response' }).subscribe(response => {
      if(response.status === 200) {
        this.getPods(permitAppropriatorId);
      }
    });
  }

  // This is the list of all PODs, used by...
  changePods(pods) {
    this.podsSource.next(pods);
  }

  // This is a single POD by POD Id, used by the new-permit component to grab the associated App Id
  changePodByPodId(pod) {
    this.podByPodIdSource.next(pod);
  }

  // This is the selected POD from the pod-form at the top of the new/exising permit page
  changePod(pod) {
    this.podSource.next(pod);
  }

}

export interface Pod {
  permitPointOfDiversionId: number,
  appropriatorId: number
  latitude: number,
  longitude: number,
  name: string,
  disabled: string,
  priorYearApplications: number[],
  diversionTypeId: number,
  diversionTypeName?: string,
  sourceName: string,
  diversionCFSMax: number,
  reachNumber: number,
  reachName: string
}
